export default __webpack_public_path__ + "static/media/kuji.0bb09bcb.png";